module.exports = __webpack_public_path__ + "static/media/tela_login_sm.0a07ec28.png";